import MobileBottomPanel from '@ui/MobileBottomPanel/component'
import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import type { MobileBottomPanelType } from '@ui/MobileBottomPanel/component'

export interface SearchMobileRecapType {
  open: () => ReturnType<MobileBottomPanelType['open']>
  enableSticky: () => void
  disableSticky: () => void
}

export default (el: HTMLElement): SearchMobileRecapType | undefined => {
  const mobileBottomPanelEl = el.querySelector<HTMLElement>('.search-mobile-recap-panel')

  if (!mobileBottomPanelEl) {
    return
  }

  const mobileBottomPanel = MobileBottomPanel(mobileBottomPanelEl)

  const contentEl = el.querySelector<HTMLElement>('.content')

  contentEl?.addEventListener('click', () => {
    mobileBottomPanel.toggle()
  })

  const obj = {
    open: () => mobileBottomPanel.open(),
    enableSticky: () => el.setAttribute('data-sticky', 'true'),
    disableSticky: () => el.removeAttribute('data-sticky'),
  }

  ElementPropertiesManager.addProperty<SearchMobileRecapType>(el, 'searchMobileRecap', obj)

  return obj
}
